<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        div.video-suggestions-control(v-show="show")
            profile-files-container-control(title="Video Suggestions")
                template(v-slot:actions)
                    div.video-suggestions-control__action-button(:class="actionButtonClass" @click="refresh")
                        svg-icon(iconId="refresh-icon")
                
                template
                    media-list-control.video-suggestions-control__list(:media="media" :mode="getMediaListMode(screenSM)" :columns="2" :class="getMediaListClass(screenSM)")
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'

export default {
    name: 'video-suggestions-control',

    components: {
        MatchMedia,
    },

    data() {
        return {
            show: false,
            media: [],
            refreshing: false,
            nextPage: 1,
        }
    },

    computed: {
        actionButtonClass() {
            return {
                'video-suggestions-control__action-button--loading': this.refreshing,
            }
        },
    },

    methods: {
        load() {
            axios.get(`/api/customer/suggestion/video?page=${this.nextPage}`).then(({data}) => {
                this.media = data.data
                this.show = this.media.length > 0
                this.refreshing = false

                const totalPages = data.meta.pagination.total_pages
                this.nextPage++

                if (this.nextPage > totalPages) {
                    this.nextPage = 1
                }
            })
        },

        refresh() {
            this.refreshing = true
            this.load()
        },

        getMediaListMode(screenSM) {
            return screenSM ? 'grid' : 'slider'
        },

        getMediaListClass(screenSM) {
            return `video-suggestions-control__list--${this.getMediaListMode(screenSM)}`
        },
    },

    created() {
        this.load()
    },
}
</script>
